import AgentProfileAvatar from '@/components/Agents/AgentProfileAvatar'
import styles from '../UserChatBubble/index.module.scss'
import { MENTION_AVATAR_PX } from './userMessageTextTokens.js'

export function MentionInMessage({ mentionToken, lookup }) {
  const label = mentionToken.startsWith('@') ? mentionToken.slice(1) : mentionToken
  const key = label.trim().toLowerCase()
  const target = lookup.get(key)
  if (!target) {
    return <span className={styles.mentionFallback}>{mentionToken}</span>
  }
  if (target.kind === 'agent') {
    return (
      <span className={styles.mentionInline}>
        <AgentProfileAvatar size={MENTION_AVATAR_PX} name={target.name} />
        <span>{mentionToken}</span>
      </span>
    )
  }
  return (
    <span className={styles.mentionInline}>
      <AgentProfileAvatar size={MENTION_AVATAR_PX} name={target.name} />
      <span>{mentionToken}</span>
    </span>
  )
}
